import axios from "axios";
import { API_URL } from "./api";

export const getNotif = async (content) => {
    try {
        await axios.post(`${API_URL}/notif/create`, {
            userId  : content.userId,
            to      : content.authorId,
            message : content.message,
            post    : content.post,
            type    : content.type || 'default'
        }, {
            headers: { Authorization: `Bearer ${content.token || localStorage.getItem('token')}` }
        });
    } catch (error) {
        console.error('Erreur lors de la création de la notification:', error.response?.data || error.message);
    }
};